import { Controller } from "@hotwired/stimulus"
import debounce from "lodash/debounce"
import axios from "axios"

const server = axios.create({
  headers: {
    "X-Requested-With": "XMLHttpRequest"
  }
})

export default class extends Controller {
  static targets = ["search", "members"]
  static values = { path: String }

  initialize() {
    this.search = debounce(this.search, 500).bind(this)
  }

  async search() {
    if (this.hasSearchTarget && this.hasMembersTarget) {
      const search = this.searchTarget.value.toLowerCase().trim()
      console.log(`Call ${this.pathValue} with`, search)
      try {
        const response = await server.get(this.pathValue, { params: { search } })
        this.membersTarget.innerHTML = response.data
      } catch (error) {
        console.error(error)
      }
    }
  }
}
